export default function IphoneAttachmentClip() {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.842 8.58441L13.842 3.91741C12.759 3.07441 11.242 3.07441 10.158 3.91741L4.158 8.58441C3.427 9.15241 3 10.0264 3 10.9524V18.2854C3 19.9424 4.343 21.2854 6 21.2854H18C19.657 21.2854 21 19.9424 21 18.2854V10.9524C21 10.0264 20.573 9.15241 19.842 8.58441Z'
        stroke='#474646'
        strokeWidth='1.5'
      />
      <path
        d='M16 14.5234C13.79 16.7334 10.208 16.7334 8 14.5234'
        stroke='#474646'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
